export type RequiredFieldStateCode = 'OPTIONAL' | 'REQUIRED' | 'HIDDEN'

export const REQUIRED_FIELD_STATES: { code: RequiredFieldStateCode, label: string }[] = [
    { code: 'OPTIONAL', label: 'Facultatif' },
    { code: 'REQUIRED', label: 'Obligatoire' },
    { code: 'HIDDEN', label: 'Masqué' },
]
